import { useState } from "react";
import { supabase } from "../supabaseClient";
import { useNavigate, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleResetPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/#/reset-password`,
    });

    if (error) {
      toast.error(t("error_sending_email"));
    } else {
      toast.success(t("check_email_reset_password"));
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center p-4">
      <div className="w-full max-w-lg">
        <div className="text-center mb-14">
          <img
            src="/logo.svg"
            alt="Omniloy Logo"
            className="w-12 h-12 mx-auto mb-4"
          />
        </div>

        <div>
          <div className="text-left mb-6">
            <Link
              to="/login"
              className="inline-flex items-center gap-2 text-sm text-[#6F7D95] hover:text-[#105BDB] mb-4"
            >
              <ArrowLeft className="w-4 h-4" />
              {t("back_to_login")}
            </Link>
            <h1 className="text-2xl font-semibold text-gray-900 mb-2">
              {t("forgot_password")}
            </h1>
            <p className="text-sm text-gray-700">
              {t("enter_email_reset_instructions")}
            </p>
          </div>

          <form onSubmit={handleResetPassword} className="space-y-6">
            <div>
              <label
                htmlFor="email"
                className="block text-lg font-bold text-black mb-2"
              >
                {t("emailLabel")}
              </label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 border border-gray-200 bg-white rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none"
                placeholder={t("emailPlaceholder")}
                required
              />
            </div>

            <button
              type="submit"
              disabled={!email || loading}
              className="w-full bg-[#105BDB] hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white font-bold py-3 px-4 rounded-md transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98] cursor-pointer"
            >
              {t("send_reset_link")}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
